/* global ga4Obj */

export default class GA4Tracking {

  static pushEvent(event, items, ecommerceData, callback) {
    this.clearDataLayer();

    let value = items
      .map(item => (item.price - item.discount) * item.quantity)
      .reduce((a, b) => a + b, 0);

    let data = {
      'event': event,
      'ecommerce': {
        'items': items,
        'currency': ga4Obj.currency,
        'value': value
      }
    };

    if (typeof ecommerceData === 'object') {
      Object.assign(data.ecommerce, ecommerceData);
    }

    window.dataLayer.push(data);

    if (typeof callback === 'function') {
      callback();
    }
  }

  static clearDataLayer() {
    if (window.dataLayer === undefined) {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      'ecommerce': null
    });
  }
}
